import { render } from "./FlagFile.vue?vue&type=template&id=6e724b1a&scoped=true"
import script from "./FlagFile.vue?vue&type=script&lang=js"
export * from "./FlagFile.vue?vue&type=script&lang=js"

import "./FlagFile.vue?vue&type=style&index=0&id=6e724b1a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e724b1a"]])

export default __exports__